import { Component, Inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AnalyticsDirective } from 'src/app/directives/analytics.directive';
import { InputDialogOptions } from './input-dialog-options';

@Component({
    imports: [
        AnalyticsDirective,
        FormsModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
    ],
    selector: 'rdx-input-dialog',
    styleUrls: ['./input-dialog.component.scss'],
    templateUrl: './input-dialog.component.html',
})
export class InputDialogComponent {
    options: InputDialogOptions | undefined;
    inputValue = new FormControl('');

    constructor(@Inject(MAT_DIALOG_DATA) data: InputDialogOptions) {
        this.options = data;
    }
}
